<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import "@/config/ba.less"
export default {
  name: 'App',
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less">
@import "./assets/font/iconfont.css";
html, body{
  width: 100%;
  height: 100%;
} 
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue